import "./App.css";
import Navbarcom from "./components/navbar/Navbarcom";
import "bootstrap/dist/css/bootstrap.min.css";
import Footer from "./components/footer/Footer";
import ServiceItem from "./components/services/serviceItem/ServiceItem";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import MainHome from "./components/mainHome/MainHome";

function App() {
  return (
    <div>
      <BrowserRouter>
        <Navbarcom />

        <Routes>
          <Route exect path="/" element={<MainHome />} />
        </Routes>

        <Routes>
          <Route path="service/:id" element={<ServiceItem />} />
        </Routes>

        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
